<div class="l-tabs-filter" *ngIf="anyFilters">
  <button type="button" *ngFor="let f of getPredefinedFilters()" [ngClass]="getFilterClass(f)"
          (click)="setFilter(f)">{{ f.Label }}</button>
</div>
